// extracted by mini-css-extract-plugin
module.exports = {"otp__success":"LoginModal_otp__success__XyNQ5","otp__success--box":"LoginModal_otp__success--box__1BIIm","otp__success--icon":"LoginModal_otp__success--icon__1-LCr"};